import { useBets } from '@hooks/queries/useBets'
import SpinningLoader from '../../../../../components/loaders/SpinningLoader'
import Pagination from '../../../../../components/ui/Pagination'
import { useState } from 'react'
import Transaction from './cards/Transaction'

const PAGE_SIZE = 15

// "All" across every filter axis pulls bets, purchases and rewards together
// (REWARD rows come back with gameCode null — the mapper already handles that).
// `page` is supplied per-render from local state so pagination re-queries.
const BASE_FILTERS = {
  type: ['BET'],
  subType: ['ALL'],
  source: ['ALL'],
  status: ['COMPLETED'],
  pageSize: PAGE_SIZE,
}

const MyTransactions = () => {
  const [currentPage, setCurrentPage] = useState(1)

  // Changing `page` changes the TanStack query key (['bets', params]), so the
  // hook refetches for the new page; keepPreviousData keeps the current rows on
  // screen until the next page arrives (no loader flash on page change).
  const { data, isPending, isError } = useBets({ ...BASE_FILTERS, page: currentPage })
  const rows = data?.rows ?? []

  if (isPending) {
    return (
      <div className="standard-normal-my-transactions-outer-container">
        <div className="standard-normal-my-transactions-inner-container">
          <div className="standard-normal-my-transactions-loading-container">
            <SpinningLoader />
          </div>
        </div>
      </div>
    )
  }

  if (isError) {
    return (
      <div className="standard-normal-my-transactions-outer-container">
        <div className="standard-normal-my-transactions-inner-container">
          <div className="standard-normal-my-transactions-error-container">
            Ooops! Something Went Wrong!
          </div>
        </div>
      </div>
    )
  }

  if (!isPending && !isError && rows.length === 0) {
    return (
      <div className="standard-normal-my-transactions-outer-container">
        <div className="standard-normal-my-transactions-inner-container">
          <div className="standard-normal-my-transactions-empty-message-container">
            No Transactions Found
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="standard-normal-my-transactions-outer-container">
      <div className="standard-normal-my-transactions-inner-container">
        <div className="standard-normal-my-transactions-list-container">
          <Transaction rows={rows} page={data?.page} />
        </div>
        <div className="standard-normal-my-transactions-pagination-container">
          <Pagination
            totalItems={data?.total}
            itemsPerPage={PAGE_SIZE}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
    </div>
  )
}

export default MyTransactions
